import {jsonMember, jsonObject} from "typedjson";

/** Свойства показетеля государственной программы */
@jsonObject
export class PitActivityStateProgramIndicatorValues {

  /** Год финансирования */
  @jsonMember({name: "year", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _year: number;

  /** Плановое или фактическое значение 1 - план, 2 - факт  */
  @jsonMember({name: "indicatorType", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _planFact: number;

  /** Значение показателя  */
  @jsonMember({name: "amount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _amount: number;

  get year(): number {
    return this._year;
  }

  set year(value: number) {
    this._year = value;
  }

  get planFact(): number {
    return this._planFact;
  }

  set planFact(value: number) {
    this._planFact = value;
  }

  get amount(): number {
    return this._amount;
  }

  set amount(value: number) {
    this._amount = value;
  }
}
